module.exports = __webpack_public_path__ + "static/media/step02.1f5b43ea.svg";